<template>
	<div class="alert alert-danger" v-if="errors.message">
		{{ $t(errors.message) }}
	</div>

	<div class="alert alert-success" v-if="done">
		{{ $t(`auth.passwordReset.${step}.passed`) }}
	</div>

	<App.Form @submit="submit">
		<App.Input :error="errors.email" v-model="form.email" v-if="step == 'email'"> Adres e-mail </App.Input>

		<template v-else>
			<App.Input :type="'password'" v-model="form.password" :error="errors.password"> Hasło </App.Input>

			<App.Input :type="'password'" v-model="form.passwordAgain" :error="errors.passwordAgain">
				Powtórz hasło
			</App.Input>
		</template>

		<div class="flex flex-space-end">
			<App.Button :loading="loadings.passwordReset">
				<template v-if="step == 'email'"> Wyślij link </template>
				<template v-else> Zmień hasło </template>
			</App.Button>
		</div>
	</App.Form>
</template>

<script setup>
	import * as App from './../components'
	import { ref, computed, getCurrentInstance } from 'vue'
	import { useRoute } from 'vue-router'
	import { useStore } from 'vuex'

	const store = useStore()
	const route = useRoute()
	const context = getCurrentInstance()

	const form = ref({})

	const step = computed(() => route.params.code ? 'password' : 'email')

	const done = computed(() => store.state.passwordReset.done)

	const submit = () => {
		store.dispatch('passwordReset', {
			payload: { ...form.value, step: step.value, code: route.params.code },
			context,
			loading: 'passwordReset'
		}).then(() => {
			form.value = {}
		})
	}
</script>
